module.exports = __webpack_public_path__ + "static/rattleorganicmain-297a1365c8eb041d98cc734bed91c1f5.jpeg";